import styles from './QuestionImgQuiz.module.css';
import { Variant } from '../../../Variant/Variant';
import { motion } from 'motion/react';

export const QuestionImgQuiz = ({
  variants,
  isStateCorrectVar,
  questionImgUrl,
  initDelay,
}) => {
  return (
    <motion.div className={styles.variantsContainer}>
      <div className={styles.variants}>
        {variants?.map((item, i) => (
          <Variant
            key={item.coment + String(i)}
            isQuestionImg
            item={item}
            index={i}
            aciveAmimate={isStateCorrectVar && item.correct}
            delayVariant={i * 0.05 + initDelay}
          />
        ))}
      </div>

      <motion.div
        className={styles.blockImgQuestion}
        initial={{ scale: 0 }}
        animate={{ scale: 1 }}
        transition={{ duration: 0.5, delay: initDelay + 1 }}
      >
        <img src={questionImgUrl} alt="" className={styles.questionImg} />
      </motion.div>
    </motion.div>
  );
};
